import wretch from 'wretch'
import AbortAddon from 'wretch/addons/abort'
import FormDataAddon from 'wretch/addons/formData'
import FormUrlAddon from 'wretch/addons/formUrl'
import QueryStringAddon from 'wretch/addons/queryString'

export const createClient = (baseUrl: string) =>
  wretch(baseUrl)
    .addon(AbortAddon())
    .addon(QueryStringAddon)
    .addon(FormUrlAddon)
    .addon(FormDataAddon)

export type Client = ReturnType<typeof createClient>
